// import type { FetchError } from "ofetch";
// import type { UseApiFetchOptions, UseApiFetchResponse } from "@edco/apollo/src/composables/useApiFetch";
import type { NitroFetchOptions } from "nitropack";
import type { MaybeRef } from "vue";
import type { AOrder, AddToBasketDto } from "@edco/apollo";
// import type { AsyncData } from "#app";

export function $nferWishlistResource () {
  const dependencies_ = useFetchDependencies();

  function createWishlist (
    title: MaybeRef<string>,
  ): Promise<string> {
    const titleUnref = unref( title );
    let url_ = "/api/nfer/wishlist/create?";
    if ( titleUnref === null ) {
      throw new Error( "The parameter 'title' cannot be null." );
    } else if ( titleUnref !== undefined ) {
      url_ += "title=" + encodeURIComponent( "" + titleUnref ) + "&";
    }
    url_ = url_.replace( /[?&]$/, "" );

    const options_: NitroFetchOptions<string> = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return $apiFetch<string>( url_, options_, dependencies_ );
  }

  function deleteWishlist (
    id?: MaybeRef<string>,
  ): Promise<boolean> {
    const idUnref = unref( id );
    if ( idUnref === undefined || idUnref === null ) {
      throw new Error( "The parameter 'id' must be defined." );
    }
    const url_ = `/api/nfer/wishlist/delete/${encodeURIComponent( idUnref.toString() )}`;
    const options_: NitroFetchOptions<string> = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };
    return $apiFetch<boolean>( url_, options_, dependencies_ );
  }

  function saveWishlist (
    request: AOrder,
  ) {
    let url_ = "/api/nfer/wishlist/save";

    url_ = url_.replace( /[?&]$/, "" );

    const regularRequest = JSON.parse( JSON.stringify( request ) );
    const content_ = JSON.stringify( regularRequest );

    const options_: NitroFetchOptions<string> = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
    };

    return $apiFetch<boolean | null>( url_, options_, dependencies_ );
  }

  function removeItemFromWishlist (
    orderId?: MaybeRef<string>,
    lineId?: MaybeRef<string>,
  ): Promise<boolean> {
    let url_ = "/api/nfer/wishlist/remove?";

    const orderIdUnref = unref( orderId );
    if ( orderIdUnref !== undefined && orderIdUnref !== null ) {
      url_ += "orderId=" + encodeURIComponent( "" + orderIdUnref ) + "&";
    }
    const lineIdUnref = unref( lineId );
    if ( lineIdUnref === null ) {
      throw new Error( "The parameter 'lineId' cannot be null." );
    } else if ( lineIdUnref !== undefined ) {
      url_ += "lineId=" + encodeURIComponent( "" + lineIdUnref ) + "&";
    }
    url_ = url_.replace( /[?&]$/, "" );

    const options_: NitroFetchOptions<string> = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };
    return $apiFetch<boolean>( url_, options_, dependencies_ );
  }

  function addToWishlist (
    dtos: MaybeRef<AddToBasketDto[]>,
    orderId?: MaybeRef<string>,
  ) {
    let url_ = "/api/nfer/wishlist/add?";

    const orderIdUnref = unref( orderId );
    if ( orderIdUnref !== undefined && orderIdUnref !== null ) {
      url_ += "orderId=" + encodeURIComponent( "" + orderIdUnref ) + "&";
    }

    url_ = url_.replace( /[?&]$/, "" );

    const regularRequest = JSON.parse( JSON.stringify( dtos ) );
    const content_ = JSON.stringify( regularRequest );

    const options_: NitroFetchOptions<string> = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
    };

    return $apiFetch<boolean | null>( url_, options_, dependencies_ );
  }

  function emailWishlist (
    id: MaybeRef<string>,
    emailAddress: MaybeRef<string>,
  ): Promise<string> {
    const idUnref = unref( id );
    let url_ = "/api/nfer/wishlist/email?";
    if ( idUnref === null ) {
      throw new Error( "The parameter 'id' cannot be null." );
    } else if ( idUnref !== undefined ) {
      url_ += "wishlistId=" + encodeURIComponent( "" + idUnref ) + "&";
    }
    const emailAddressUnref = unref( emailAddress );
    if ( emailAddressUnref === null ) {
      throw new Error( "The parameter 'emailAddress' cannot be null." );
    } else if ( emailAddressUnref !== undefined ) {
      url_ += "emailAddress=" + encodeURIComponent( "" + emailAddressUnref );
    }
    url_ = url_.replace( /[?&]$/, "" );

    const options_: NitroFetchOptions<string> = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return $apiFetch<string>( url_, options_, dependencies_ );
  }

  return {
    createWishlist,
    deleteWishlist,
    saveWishlist,
    removeItemFromWishlist,
    addToWishlist,
    emailWishlist,
  };
}
